import { render, staticRenderFns } from "./OperationSetting.vue?vue&type=template&id=089f84b4"
import script from "./operation-setting.ts?vue&type=script&lang=ts&external"
export * from "./operation-setting.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports